import { render } from "./PatientInfo.vue?vue&type=template&id=bec01e00&scoped=true"
import script from "./PatientInfo.vue?vue&type=script&lang=js"
export * from "./PatientInfo.vue?vue&type=script&lang=js"

import "./PatientInfo.vue?vue&type=style&index=0&id=bec01e00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bec01e00"]])

export default __exports__